import React from 'react';
import { connect } from 'react-redux';
import del from '../Res/Icon/delete.png';
import recover from '../Res/Icon/recover.png';
import VmailPlayer from './VmailPlayer';
import utils from '../lib/utils';

const Vmails = ({ vmails, onDelete, onDownload, currentUser, deleteMode, onRecover }) => {
  const { _id: id, receivedOn, user, company, receivedFrom, vmailPath } = vmails;
  return (
    <tr>
      <td>{(company && company.name) || ''}</td>
      <td>{(user && user.email) || ''}</td>
      <td>{utils.getDateTimeFormat(receivedOn, 'regular')}</td>
      <td>{receivedFrom || '-'}</td>
      {!deleteMode ? (
        <td style={{ display: 'flex', justifyContent: 'space-evenly' }}>
          {currentUser.role !== 'companyGroupAdmin' &&
            currentUser.role !== 'companyGroupManager' &&
            currentUser.role !== 'admin' ? (
            <img
              onClick={() => {
                onDelete(id);
              }}
              className="actions-icon"
              src={del}
              alt="delete"
            />
          ) : null}

          {currentUser.role === 'user'
            ? vmailPath && vmailPath !== null && <VmailPlayer id={id} type="vmails" />
            : null}
        </td>
      ) : (
        <td style={{ display: 'flex', justifyContent: 'space-evenly' }}>
          {currentUser.role === 'superAdmin' ? (
            <>
              {/* <Button
                color="danger"
                onClick={() => {
                  onDelete(id);
                }}
                title="Delete"
              >
                Delete
              </Button> */}
              <img
                onClick={() => {
                  onDelete(id);
                }}
                className="actions-icon"
                src={del}
                alt="delete"
              />
              {/* <Button
                color="info"
                title="Recover"
                onClick={() => {
                  onRecover(id);
                }}
              >
                Recover
              </Button> */}
              <img
                onClick={() => onRecover(id)}
                className="actions-icon"
                src={recover}
                alt="recover"
              />
            </>
          ) : null}
        </td>
      )}
    </tr>
  );
};

const mapStateToProps = state => ({
  currentUser: state.AppState.user,
});

export default connect(mapStateToProps)(Vmails);
